import {
  IAction,
  IAnyValueAction,
  IAnyValuesAction,
  IBooleanValueAction,
  INumericValueAction,
  INumericValuesAction
} from "../../../redux/actions";
import { IAutoplaySetting } from "./AutoplaySettings";

export enum types {
  SET_ADVANCED_SETTINGS = "SET_ADVANCED_SETTINGS",
  UPDATE_ADVANCED_SETTING = "UPDATE_ADVANCED_SETTING",
  TRIGGER_UPDATE_ADVANCED_SETTING_CHANGE_REQUEST = "TRIGGER_UPDATE_ADVANCED_SETTING_CHANGE_REQUEST",
  TRIGGER_AUTOPLAY_SETTINGS_RESET_REQUEST = "TRIGGER_AUTOPLAY_SETTINGS_RESET_REQUEST",
  SET_ROUNDS_LEFT = "SET_ROUNDS_LEFT",
  SELECT_ROUNDS = "SELECT_ROUNDS",
  TRIGGER_SELECT_ROUNDS_CHANGE_REQUEST = "TRIGGER_SELECT_ROUNDS_CHANGE_REQUEST",
  RESET_ROUNDS = "RESET_ROUNDS",
  START_AUTOPLAY = "START_AUTOPLAY",
  STOP_AUTOPLAY = "STOP_AUTOPLAY",
  SET_ROUNDS_VALUES = "SET_ROUNDS_VALUES",
  SET_AVAILABLE = "SET_AVAILABLE",
  SHOW_ADVANCED_SETTINGS = "SHOW_ADVANCED_SETTINGS"
}

export const setRoundsLeft = (value: number): INumericValueAction => {
  return {
    type: types.SET_ROUNDS_LEFT,
    value
  };
};

export const selectRounds = (value: number): INumericValueAction => {
  return {
    type: types.SELECT_ROUNDS,
    value
  };
};

export const triggerAutoplayRoundsChangeRequest = (
  value: number
): INumericValueAction => {
  return {
    type: types.TRIGGER_SELECT_ROUNDS_CHANGE_REQUEST,
    value
  };
};

export const setRoundsValues = (values: number[]): INumericValuesAction => {
  return {
    type: types.SET_ROUNDS_VALUES,
    values
  };
};

export const resetRounds = (): IAction => {
  return {
    type: types.RESET_ROUNDS
  };
};

export const startAutoplay = (): IAction => {
  return {
    type: types.START_AUTOPLAY
  };
};

export const stopAutoplay = (): IAction => {
  return {
    type: types.STOP_AUTOPLAY
  };
};

export const setAvailable = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_AVAILABLE,
    value
  };
};

export const setSettings = (values: IAutoplaySetting[]): IAnyValuesAction => {
  return {
    type: types.SET_ADVANCED_SETTINGS,
    values
  };
};

export const updateSetting = (value: IAutoplaySetting): IAnyValueAction => {
  return {
    type: types.UPDATE_ADVANCED_SETTING,
    value
  };
};

export const triggerAutoplaySettingChangeRequest = (
  value: IAutoplaySetting
): IAnyValueAction => {
  return {
    type: types.TRIGGER_UPDATE_ADVANCED_SETTING_CHANGE_REQUEST,
    value
  };
};

export const triggerAutoplaySettingsResetRequest = (): IAction => {
  return {
    type: types.TRIGGER_AUTOPLAY_SETTINGS_RESET_REQUEST
  };
};
